module.exports = __webpack_public_path__ + "static/Skills-ScreenCraft-8b31e146af81ce3d5ba50ad04964eeb7.svg";